import PropTypes from "prop-types";
import React, { Component } from "react";
import { graphql } from "react-apollo";
import { BounceLoader } from "react-spinners";
import { Spinner } from "reactstrap";
import { SET_TOKEN } from "../../mutations.local";

class GraphQLResult extends Component {
  static propTypes = {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    children: PropTypes.any,
    error: PropTypes.object,
    loading: PropTypes.bool,
    clipLoader: PropTypes.bool,
    loadingColor: PropTypes.string,
    renderError: PropTypes.func,
    setToken: PropTypes.func.isRequired,
    clipLoaderSize: PropTypes.string,
    emptyResult: PropTypes.bool,
    emptyResultMsg: PropTypes.string,
    withFragment: PropTypes.bool,
    noSpinner: PropTypes.bool,
  };

  static defaultProps = {
    className: "graphql-result",
    containerClassName: "",
    withFragment: false,
    clipLoader: true,
    clipLoaderSize: "md",
    loadingColor: "warning",
    renderError: null,
    emptyResult: false,
    emptyResultMsg: "Aucun élément n'a été trouvé !",
    children: null,
    noSpinner: false,
  };

  _renderLoader = () => {
    const {
      noSpinner,
      clipLoader,
      loadingColor,
      containerClassName,
      clipLoaderSize,
    } = this.props;
    return (
      <div className={`graphql-result__container ${containerClassName}`.trim()}>
        {noSpinner ? null : clipLoader ? (
          <Spinner size={clipLoaderSize} color={loadingColor} />
        ) : (
          <BounceLoader color={loadingColor} size={35} />
        )}
      </div>
    );
  };

  _renderError = () => {
    const { error, renderError } = this.props;
    if (error.networkError && error.networkError.statusCode === 401) {
      this.props.setToken();
    } else if (error.graphQLErrors && error.graphQLErrors[0]) {
      const errorMsg = error.graphQLErrors[0].message;
      if (renderError) return renderError(errorMsg);
    }
  };
  _renderBody = () => {
    const {
      loading,
      children,
      error,
      containerClassName,
      emptyResult,
      emptyResultMsg,
    } = this.props;
    return loading ? (
      this._renderLoader()
    ) : error ? (
      this._renderError()
    ) : emptyResult ? (
      <div className={`${containerClassName} p-sm-5 text-info text-center`}>
        {emptyResultMsg}
      </div>
    ) : (
      children
    );
  };

  render() {
    const { className, withFragment } = this.props;
    return (
      <React.Fragment>
        {withFragment ? (
          <React.Fragment> {this._renderBody()}</React.Fragment>
        ) : (
          <div className={className}>{this._renderBody()}</div>
        )}
      </React.Fragment>
    );
  }
}

export default graphql(SET_TOKEN, {
  name: "setToken",
})(GraphQLResult);
